<template>
  <div>
    <!-- 客户数据分析 -->
    <baseBreadcrumb :page="$t('message.basicInformation')" :menu="$t('message.customerDataAnalysis')"></baseBreadcrumb>
    <!-- 客户账号信息 -->
    <div class="body">
      <div class="head">
        <img :src="detail.portrait_url" alt="">
        <div class="text">
          <div class="name">
            <!-- 客户名 -->
            <div class="item user">
              {{ $t('message.customerName') }}:{{ detail.realname }}
            </div>
            <!--  -->
            <div class="item user">
              ID:{{ detail.id }}
            </div>
            <!-- 担当 -->
            <div class="item">
              {{ $t('message.takeOn') }}:{{ detail.y_name }}
            </div>
            <!-- 采购 -->
            <div class="item">
              {{ $t('message.purchase') }}:{{ detail.g_name }}
            </div>
            <!-- 配货 -->
            <div class="item">
              {{ $t('message.distribution') }}:{{ detail.p_name }}
            </div>
          </div>
          <!-- 上次访问时间 -->
          <div class="time"> {{ $t('message.lastAccessTime') }}：{{ detail.last_login_at }}</div>
        </div>
      </div>
      <!-- tabs -->
      <div class="tabs">
        <!-- 概况信息 -->
        <div class="item" :class="{ select: index == 1 }" @click="index = 1">
          {{ $t('message.overviewInformation') }}
        </div>
        <!-- 订单信息 -->
        <div class="item" :class="{ select: index == 2 }" @click="index = 2">
          {{ $t('message.orderInformation') }}
        </div>
        <!-- 配送单信息 -->
        <div class="item" :class="{ select: index == 3 }" @click="index = 3">
          {{ $t('message.deliveryNoteInformation') }}
        </div>
        <!-- 问题产品 -->
        <div class="item" :class="{ select: index == 4 }" @click="index = 4">
          {{ $t('message.Problem') }}
        </div>
        <!-- 售后管理 -->
        <div class="item" :class="{ select: index == 5 }" @click="index = 5">
          {{ $t('message.afterSalesManagement') }}
        </div>
      </div>
      <!-- 概况信息 -->
      <overviewInformation v-if="index == 1" />
      <!-- 订单信息 -->
      <orderInformation v-if="index == 2" />
      <!-- 配送单信息 -->
      <deliveryNoteInformation v-if="index == 3" />
      <!-- 问题产品 -->
      <problemProducts v-if="index == 4" />
      <!-- 售后管理 -->
      <afterSalesManagement v-if="index == 5" />
    </div>
  </div>
</template>
<script>
import overviewInformation from './components/overviewInformation'
import orderInformation from './components/orderInformation'
import deliveryNoteInformation from './components/deliveryNoteInformation'
import problemProducts from './components/problemProducts'
import afterSalesManagement from './components/afterSalesManagement'
export default {
  components: {
    overviewInformation, orderInformation, deliveryNoteInformation, problemProducts, afterSalesManagement
  },
  data() {
    return {
      index: 1,
      user_id: this.$route.query.userID,
      detail: {}
    };
  },
  created() {
    this.userBasicsInfo()
  },
  methods: {
    // 客户详情
    userBasicsInfo() {
      this.$api.clienteleApi.userBasicsInfo({ user_id: this.user_id }).then((res) => {
        this.detail = res.data
      });
    },
  }
}
</script>
<style lang='scss' scoped>
.head {
  display: flex;
  border: 1px solid #ccc;
  padding: 24px;

  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 24px;
  }

  .text {
    display: flex;
    justify-content: space-between;
    flex: 1;

    .name {
      display: flex;
      align-items: center;

      .item {
        margin-right: 24px;
      }

    }

    .user {
      font-size: 18px;
      font-weight: 600;
    }

    .time {
      display: flex;
      align-items: center;
    }
  }
}

.tabs {
  padding: 24px;
  border: 1px solid #ccc;
  border-top: 0;
  display: flex;
  margin-bottom: 24px;

  .item {
    margin-right: 48px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
  }

  .select {
    color: #b4272d;
  }
}
</style>